// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1shyt","productName":"Table_productName__20rCs"};